<template>
  <widget-container
      headlineclass
      cardclass=" ma-0 pa-1"
      :url="url"
      :bus="bus"
      :dark="false"
      :flat="false"
      color="transparent"
      :alwaysrender="true"
      @ready="setData"
  >
    <template slot="content">
      <div class>
        <v-row align="center">
          <v-col class="mb-3 text-right">
            <v-btn @click="copy" small depressed :disabled="this.table.items.length==0">
              <v-icon small>mdi-clipboard-outline</v-icon>
              Copier
            </v-btn>
          </v-col>
        </v-row>
        <div :style="'overflow-x: auto;' ">
          <div :style="'width:'+tableWidth+'px;border: 1px solid #e1e1e1;margin:auto;overflow:clip;'" class="mb-6">
            <v-data-table
                v-model="table.items"
                :headers="table.headers"
                :items="table.items"
                :loading="table.loading"
                :items-per-page="1000"
                hide-default-footer
                no-data-text="Aucun message en attente"
                item-key="name"
                item-class="border-y"
                @click:row="expand"
                item-style="background-color:white"
            >

              <template v-for="(header,i) in table.headers"
                        v-slot:[`item.${header.value}`]="{ item }">
                <div :style="{width: header.value ==='hotel'? '250px' : '154px', cursor:'pointer'}" :key="header+'_'+i" class="text-no-wrap">
                  <v-icon v-if="i===0">{{ upOrDown(item) ? 'mdi-menu-down' : 'mdi-menu-up' }}</v-icon>
                  <span>{{ getItemValue(header, item, 'nights') }}</span>
                </div>
              </template>

              <template #expanded-item="{item , headers}">
                <td :colspan="headers.length" class="px-0" style="width:99%;">
                  <div v-for="(hotel,i) in item.hotelsNights" :key="i" style="height:30px;cursor:pointer;"
                       class="scrollHidden d-flex grey lighten-3">
                    <div v-for="header in headers" :key="header.value"
                         :style="{width: header.value =='hotel'? '283px' : '187px'}"
                         style="text-wrap: nowrap;"
                         class="my-auto scrollHidden overflow-hidden"
                         :class="[header.value == 'hotel' ? 'pl-8 pr-0': 'px-4']">
                      <v-tooltip :open-delay="1" bottom :disabled="header.value != 'hotel'">
                        <template #activator="{on}">
                          <div v-on="on"  >{{ getItemValue(header, hotel, 'years') }}</div>
                        </template>
                        <span  class="scrollHidden ">{{ getItemValue(header, hotel, 'years') }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </td>
              </template>

              <template #foot>
                <tr class="font-weight-medium border-y" v-if="table.total != null">
                  <td class=" font-weight-medium body-1 pl-4 py-2" :style="{width: '250px'}">{{
                      table.total.hotel
                    }}
                  </td>
                  <td v-for="(year,i) in table.total.years" :key="'_'+i+year" class="body-1 px-4 font-weight-medium"
                      :style="{width:'154px'}">
                    {{ year.value }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </template>
  </widget-container>
</template>

<script>
import WidgetContainer from "./WidgetContainer";
import clipboard from "@/utils/clipboard";

export default {
  name: "WidgetNightsPerChains",
  components: {WidgetContainer},
  mixins: [],
  props: {
    bus: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    withLastYear: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      table: {
        loading: false,
        items: [],
        rowsPerPageItems: [{text: "Tous", value: -1}],
        headers: [],
        total: null,

      },
      expanded: [],
    };
  },
  created() {
    this.$nextTick(() => {
      this.bus.$on("search", (searchform) => {
        this.table.loading = true;
      });
    });
  },
  destroyed() {
    this.bus.$off("search");
  },
  watch: {},
  computed: {
    tableWidth() {
      if (this.table.headers.length > 0) {
        const width = this.table.headers
            //.filter(h => this.table.selectedHeaders.length <= 0 ? true : this.doShowColumn(h.value))
            .map((h) => (this.withLastYear ? h.fullSize : h.smallSize))
            .reduce((acc, curr) => acc + curr);
        return width;
      } else return 800;
    },
  },
  methods: {
    expand(data, row, event) {
      if (this.expanded.includes(row.item.chainId)) {
        const index = this.expanded.indexOf(row.item.chainId);
        this.expanded.splice(index, 1)
      } else {
        this.expanded.push(row.item.chainId)
      }
      row.expand(!row.isExpanded);
    },
    setData(data) {

      this.table.loading = true;
      this.table.headers = [
        {text: "Chaîne", fullSize: 350, smallSize: 230, value: "hotel"},
        ...data.headers.map((year) => {
              return {
                text: year,
                fullSize: 150,
                smallSize: 150,
                value: year,
              }
            }
        ),
      ];

      this.table.items = data.items
      this.table.total = {
        hotel: "Total:",
        hotelId: 0,
        years: data.total.map(t => t.nights)
      }
      this.table.loading = false
    },
    getItemValue(header, item, props) {
      const val = item[props].find(year => year.name === header.value.toString())

      if (header.value === 'hotel') {
        return props === 'nights' ? item.name : item.hotel
      } else {
        return val != null && val.value !== 0 ? val.value : ''
      }

    },
    upOrDown(item) {
      return this.expanded.includes(item.chainId)
    },
    copy() {
      const defaultSeparator = "\t";

      const headers = this.table.headers
          .map((h, i) => {
            return `${h.text}${defaultSeparator} ${i == 0 ? 'Hôtel' + defaultSeparator : ''}`;
          })
          .join(" ");

      const rows = this.table.items.map((i) => {
        const chain = i.nights.sort((a, b) => parseInt(b.name) - parseInt(a.name))
            .map((m) => `${m.value}${defaultSeparator}`).join(" ");

        const chainRow = `${i.name}${defaultSeparator} ${defaultSeparator}${chain}`;
        const hotelRows = i.hotelsNights.map(hNight => {
          const valueCells = hNight.years.sort((a, b) => parseInt(b.name) - parseInt(a.name)).map(c => `${c.value}`);
          return ` ${defaultSeparator}${hNight.hotel}${defaultSeparator}${valueCells.join(defaultSeparator)}`;
        }).join(" \n ")

        const rows = [chainRow]
        return [rows].concat(hotelRows).join("\n");
      });

      const total = this.table.total.years.map((i, index) => {
        return `${index == 0 ? defaultSeparator : ''}${i.value}${defaultSeparator}`;
      })
      const totalRow = [this.table.total.hotel]

      totalRow.push([...total].join(" "))


      const allRows = [headers].concat(rows.join(" \n "), totalRow.join("\t"));

      clipboard.copyTextToClipboard(allRows.join(" \n "));
    },
  }
};
</script>

<style scoped>
.border-y {
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
}

>>> .theme--light.v-data-table tbody tr.v-data-table__selected {
  background: white;
}

>>> .v-data-table__wrapper {
  overflow-x: hidden;
}

>>> .v-data-table__expanded__content {
  box-shadow: 0 0 0 0 transparent !important;
}

.scrollHidden {
  scrollbar-arrow-color: white;
  scroll-margin: 0px;
  scrollbar-darkshadow-color: white;
}

</style>

